import { Injectable } from '@angular/core';
import {HttpClient, HttpClientModule , HttpHeaders} from '@angular/common/http' ;
import {AppConstant} from '../AppConstant'
import {Product} from '../landing-page/product.model';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {

  constructor(public httpClient :  HttpClient) { }

  viewAllProducts = 'products';
  viewByProductId = 'products/'
  productId : any;

  ViewAllProductsFunctions(){
    console.log("In ViewAllProductsFunctions service");
    console.log(AppConstant.baseURL + this.viewAllProducts);
    return this.httpClient.get(AppConstant.baseURL + this.viewAllProducts);
  }

  ViewAllProductsByIdFunctions(productId : number){
    console.log("In ViewAllProductsByIdFunctions service");
    console.log(AppConstant.baseURL + this.viewAllProducts + productId);
    return this.httpClient.get<Product[]>(AppConstant.baseURL + this.viewAllProducts + productId);
  }
}
